<div class="mb-25">
  <!-- Breadcrumb removed but spacing maintained -->
</div>

<div class="allocations-container">
  @for (allocation of filteredAllocations; track allocation) {
    <div class="col-lg-4 col-md-6 allocation-card">
      <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
          <mat-card-title>
            <h5 class="mb-0">{{ allocation.organizationName }}</h5>
          </mat-card-title>
          <mat-card-subtitle>
            <p></p>
          </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <p>
            <strong>Organizacija:</strong> {{ allocation.organizationName }}
          </p>
          <p>
            <strong>Aktivnost:</strong> {{ allocation.activityName }}
          </p>
          <p>
            <strong>Traženi iznos:</strong> {{ allocation.amountRequestedFromMunicipality | currency:'EUR' }}
          </p>
          <p>
            <strong>Datum predaje:</strong> {{ allocation.submittedAt | date: 'd.M.yyyy. HH:mm:ss' }}
          </p>
          <p>
            <strong>Status:</strong>
            <span
              class="daxa-badge"
                    [ngClass]="{
                      'submited': allocation.status === AllocationStatus.Submitted,
                      'draft': allocation.status === AllocationStatus.Draft,
                      'returned': allocation.status === AllocationStatus.Returned,
                      'resubmitted': allocation.status == AllocationStatus.Resubmitted,
                      'approved': allocation.status === AllocationStatus.Approved,
                      'rejected': allocation.status === AllocationStatus.Rejected
                    }"
              >
              {{ allocation.userFriendlyStatus }}
            </span>
          </p>
        </mat-card-content>
        <mat-card-actions>
          <button mat-icon-button color="primary" matTooltip="Pregledaj dodjelu" (click)="goToViewAllocation(allocation)">
            <mat-icon>visibility</mat-icon>
          </button>
          @if (allocation.isActionAllowed('Return')) {
            <button mat-icon-button color="primary" matTooltip="Vrati izravnu dodjelu na doradu" (click)="confirmReturn(allocation)">
              <mat-icon>reply</mat-icon>
            </button>
          }
          @if (allocation.isActionAllowed('Approve')) {
            <button mat-icon-button color="primary" matTooltip="Odobri izravnu dodjelu" (click)="confirmApprove(allocation)">
              <mat-icon>check_circle</mat-icon>
            </button>
          }
          @if (allocation.isActionAllowed('Reject')) {
            <button mat-icon-button color="warn" matTooltip="Odbij izravnu dodjelu" (click)="confirmReject(allocation)">
              <mat-icon>cancel</mat-icon>
            </button>
          }
          <button mat-icon-button color="primary" matTooltip="Preuzmi obrasce" (click)="downloadForms(allocation, [AllocationFormType.B1, AllocationFormType.B2])">
            <mat-icon>download</mat-icon>
          </button>
          @if (allocation.isActionAllowed('CreateProject')) {
            <button mat-icon-button color="primary" matTooltip="Kreiraj projekt iz zahtjeva za izravnom dodjelom sredstava" (click)="goToCreateProject(allocation)">
              <mat-icon>description</mat-icon>
            </button>
          }
        </mat-card-actions>
      </mat-card>
    </div>
  }
</div>
